export default __webpack_public_path__ + "static/ciel_intro-8c60ece458d825c7ffe61877e615045c.jpg";